import styled from 'styled-components';
import ds from 'designsystem';

/* Disable ESlint rules for this file */
/* eslint no-confusing-arrow: "off" */
/* eslint react/destructuring-assignment: "off" */

const Arrow = styled.span`
    width: 8px;
    height: 8px;
    display: ${props => props.isActive ? 'none' : 'block'};
    border: solid black;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
    margin-right: ${ds.get('metrics.base')};
    position: relative;
    top: 9px;
`;

export default Arrow;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/PanelGroup/Arrow.jsx